import { ApiUrl } from "../../../Constants/Api";
import {
  REQUEST_METHOD,
  WebService,
} from "../../WebServiceManager/RequestService";
import LoginRequestBody from "./LoginRequestBody";

export default class LoginService {
  request = new LoginRequestBody();
  static shared = new LoginService();

  loginRequest = (payload) => {
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.loginRequest(),
          this.request.loginRequest(payload, REQUEST_METHOD.POST)
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  forgotPasswordRequest = (payload) => {
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.forgotPasswordRequest(payload.email),
          
          this.request.forgotPasswordRequest( REQUEST_METHOD.POST)
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  resetPasswordRequest = (payload) => {
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.resetPasswordRequest(payload.token),
          this.request.resetPasswordRequest(REQUEST_METHOD.PUT,{newPassword: payload.newPassword, confirmPassword:payload.confirmPassword})
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  updatePasswordRequest = (payload ) => {
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.updatePasswordRequest(),
          
          this.request.updatePasswordRequest(payload, REQUEST_METHOD.PUT) // requestbody
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  resetExpiryPasswordRequest = (payload ,id) => {
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.resetExpiryPasswordRequest(id),
          
          this.request.resetExpiryPasswordRequest(payload, REQUEST_METHOD.PUT) // requestbody
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  profileRequest = (payload) => {
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.getUserById(payload),
          this.request.profileRequest(REQUEST_METHOD.GET)
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  backgroundImageRequest = (payload) => {
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.getBackgroundImage(payload),
          this.request.backgroundImageRequest(REQUEST_METHOD.GET)
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };



}
